import type { ConversationListItem } from '@tandemone/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { markConversationRead } from './api'
import { CONVERSATIONS_LIST_KEY, CONVERSATIONS_UNREAD_KEY } from './keys'

/** mark a conversation read. server bumps last_read_at on the caller's
 * participant row and broadcasts a read_receipt to the conversation room +
 * an unread_changed to the caller's user room. we still invalidate the
 * unread-count locally on success as belt-and-suspenders, and zero out
 * the per-row badge in the cached list so it doesn't stick until the
 * next refetch (the socket read_receipt only patches lastReadAt).
 */
export function useMarkConversationRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (conversationId: string) =>
      markConversationRead(conversationId),
    onSuccess: (_data, conversationId) => {
      void queryClient.invalidateQueries({
        queryKey: CONVERSATIONS_UNREAD_KEY
      })
      queryClient.setQueryData<{ items: ConversationListItem[] } | undefined>(
        CONVERSATIONS_LIST_KEY,
        old => {
          if (!old) return old
          return {
            ...old,
            items: old.items.map(item =>
              item.id === conversationId ? { ...item, unreadCount: 0 } : item
            )
          }
        }
      )
    }
  })
}
